import React, { forwardRef } from "react"

import { ReactComponent as GoogleLogo } from "@common_assets/svg/google-color.svg"
import { Box, Button } from "@mui/material"
import SsoButtonContent from "components/common/ssoButtonContent"
import {
  ssoButtonVisualLayerSx,
  ssoGoogleButtonSx,
  ssoGoogleHiddenTargetSx,
} from "components/common/ssoButtonContent/ssoButton.styles"

interface IProps {
  checked?: boolean
  isSignUp?: boolean
  onClick?: () => void
  text: string
}

type Ref = HTMLDivElement

const GoogleButton = forwardRef<Ref, IProps>(
  ({ checked, isSignUp, text, onClick }, ref) => {
    return (
      <Button
        onClick={onClick}
        variant="outlined"
        fullWidth
        sx={(theme) => ssoGoogleButtonSx(theme)}
      >
        <Box ref={ref} sx={ssoGoogleHiddenTargetSx(!!isSignUp, checked)} />
        <Box sx={ssoButtonVisualLayerSx}>
          <SsoButtonContent icon={<GoogleLogo aria-hidden="true" />} text={text} />
        </Box>
      </Button>
    )
  },
)

GoogleButton.displayName = "GoogleButton"

export default GoogleButton
